import { type FC } from 'react';

import ConsultationCard from '@/components/ConsultationCard';

import type { ThisProduct } from '../CreatorBySlug';

import s from './Consultations.module.scss';

const Consultations: FC<{ consultationProducts: ThisProduct[]; creatorSlug: string }> = ({
  consultationProducts,
  creatorSlug,
}) => (
  <div className={s.consultations}>
    <h2>Book a Consultation</h2>
    {consultationProducts
      .filter(
        (product) =>
          product.isActive &&
          product.prices.length > 0 &&
          product.prices.some((price) => price.isActive) &&
          product.showOnOneLink,
      )
      .map((product, index) => (
        <ConsultationCard key={product.id} product={product} creatorSlug={creatorSlug} open={index === 0} />
      ))}
  </div>
);

export default Consultations;
